import React from 'react';
import { Accordion, AccordionPanel } from 'rc-easyui';
/**
 * 所有Find的檢查結果，右下角的顯示區域
 */

const StyleCheckResultList = ({ _WaveformView }) => {
  function NumberList(props) {
    const error = props.error;
    const listItems =
      error &&
      error.map((obj, index) => {
        const { rowIndex, errorMessage } = obj;

        return (
          <li key={index.toString()}>
            <a
              onClick={() => {
                _WaveformView.moveCellSelect(rowIndex);
                _WaveformView.setDragHandleDragValue_byIndex(rowIndex);

                //移動到上面
                _WaveformView.hotTableComponent.current.hotInstance.scrollViewportTo(
                  rowIndex,
                  4
                );
              }}
            >
              Line {rowIndex + 1} {errorMessage}
            </a>
          </li>
        );
      });

    return <ul>{listItems}</ul>;
  }
  return (
    <div>
      {_WaveformView.StyleData ? (
        <Accordion multiple panelHeight='auto' animate>
          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Frame split error']
          ) !== '[]' ? (
            <AccordionPanel title='Frame split error'>
              {_WaveformView.StyleData.TotalErrorData ? (
                <NumberList
                  error={
                    _WaveformView.StyleData.TotalErrorData['Frame split error']
                  }
                />
              ) : null}
            </AccordionPanel>
          ) : (
            <div />
          )}

          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Character limit']
          ) !== '[]' ? (
            <AccordionPanel title='Character limit'>
              <NumberList
                error={
                  _WaveformView.StyleData.TotalErrorData['Character limit']
                }
              />
            </AccordionPanel>
          ) : (
            <div />
          )}

          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Duration error']
          ) !== '[]' ? (
            <AccordionPanel title='Duration error'>
              <NumberList
                error={_WaveformView.StyleData.TotalErrorData['Duration error']}
              />
            </AccordionPanel>
          ) : (
            <div />
          )}

          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Max line count error']
          ) !== '[]' ? (
            <AccordionPanel title='Max line count error'>
              <NumberList
                error={
                  _WaveformView.StyleData.TotalErrorData['Max line count error']
                }
              />
            </AccordionPanel>
          ) : (
            <div />
          )}

          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Maximum & Minimum length']
          ) !== '[]' ? (
            <AccordionPanel title='Maximum & Minimum length'>
              <NumberList
                error={
                  _WaveformView.StyleData.TotalErrorData[
                    'Maximum & Minimum length'
                  ]
                }
              />
            </AccordionPanel>
          ) : (
            <div />
          )}

          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Maximun & Minimum Duration']
          ) !== '[]' ? (
            <AccordionPanel title='Maximun & Minimum Duration'>
              <NumberList
                error={
                  _WaveformView.StyleData.TotalErrorData[
                    'Maximun & Minimum Duration'
                  ]
                }
              />
            </AccordionPanel>
          ) : (
            <div />
          )}

          {JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Character Per Second']
          ) !== '[]' ? (
            <AccordionPanel title='Character Per Second'>
              <NumberList
                error={
                  _WaveformView.StyleData.TotalErrorData['Character Per Second']
                }
              />
            </AccordionPanel>
          ) : (
            <div />
          )}



{JSON.stringify(
            _WaveformView.StyleData.TotalErrorData['Timecode Error']
          ) !== '[]' ? (
            <AccordionPanel title='Timecode Error'>
              <NumberList
                error={
                  _WaveformView.StyleData.TotalErrorData['Timecode Error']
                }
              />
            </AccordionPanel>
          ) : (
            <div />
          )}
          
        </Accordion>
      ) : null}
    </div>
  );
};

export default StyleCheckResultList;



// WEBPACK FOOTER //
// ./src/components/drogable/FindResult/StyleCheckResultList.js